/* eslint-disable max-len */
/* eslint-disable no-console */
import { API } from 'aws-amplify';
import {
	UPDATE_ACCESS_SETTINGS,
	UpdateAccessSettingsPayload,
	AccessSettings
} from './types';

// API endpoint name as configured in index.tsx
const REVISED_RESOURCES = 'revisedResources';

/**
 * Update the access settings
 * @param companyId - Company identifier
 * @param payload - Object containing the updated access settings
 * @returns The updated access settings configuration
 */
const updateAccessSettings = async (
	companyId: string,
	payload: UpdateAccessSettingsPayload
): Promise<{ accessSettings: AccessSettings }> =>
{
	try
	{
		const response = await API.patch(
			REVISED_RESOURCES,
			`/configurations/${companyId}/access-settings`,
			{
				body : payload
			}
		);

		// Return the updated configuration
		if (response?.data?.accessSettings)
		{
			return {
				accessSettings : response.data.accessSettings
			};
		}

		// If no access settings in response, return what we sent
		// This handles edge cases where the API doesn't return the updated data
		return {
			accessSettings : {
				public   : true,
				private  : true,
				download : true,
				share    : true,
				...payload
			}
		};
	}
	catch (error)
	{
		console.error('Error updating access settings:', error);
		throw error;
	}
};

const getResourceAccessSettings = async (companyId: string): Promise<any> =>
{
	try
	{
		return await API.get(REVISED_RESOURCES, `/configurations/${companyId}`, {});
	}
	catch (error)
	{
		console.error('Error fetching resource access settings:', error);
		throw error;
	}
};

export { updateAccessSettings, getResourceAccessSettings };